<template>
  <div class="s-item">
    <div class="s-item-info">
      <div class="s-space-y-2 s-mr-auto w-full">
        <template v-if="fields.length > 0">
          <p
            v-for="(field, i) in fields"
            class="s-text-gray s-text-xs"
            v-bind:key="i"
          >
            {{ field.value }}{{ getFieldValue(field) }}
          </p>
        </template>
        <template v-else>
          <p class="s-text-gray s-text-xs s-whitespace-nowrap">
            預約時間：{{ bookingDateText }}
          </p>
          <p class="s-text-gray s-text-xs s-whitespace-nowrap">
            預約狀態：{{ booking.status }}
          </p>
        </template>
        <div class="w-full d-flex align-items-start justify-content-end">
          <div v-for="(sdConfig, index) in bookingStatusMapping.inform_button" :key="'inform-' + index" >
            <StatusDetector
              :status="booking.status"
              :config="sdConfig"
              enviroment="liff"
              page="list"
            />
          </div>
          <div v-for="(sdConfig, index) in bookingStatusMapping.status_change_button" :key="'status-change-' + index" >
            <StatusDetector
              :status="booking.status"
              :config="sdConfig"
              enviroment="liff"
              page="list"
              @buttonAction="updateStatus"
            />
          </div>
          <div v-if="isCanView" class="mr-2">
            <SharedButton variant="outline-dark" class="s-btn-outline-primary list-button" block @click="goToView()">
              查看
            </SharedButton>
          </div>
          <div v-if="isCanReadOnly" class="mr-2">
            <SharedButton variant="outline-dark" class="s-btn-outline-primary list-button" block @click="goToReadOnly()">
              檢視
            </SharedButton>
          </div>
          <div v-if="isCanEdit">
            <SharedButton variant="outline-dark" class="s-btn-outline-primary list-button" block @click="goToEdit()">
              編輯
            </SharedButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import StatusDetector from "@/components/StatusDetector.vue";
import SharedButton from "@/components/Page/Liff/Shared/Button.vue";
import bookingApi from "@/apis/liff/v2/booking";

export default {
  components: {
    StatusDetector,
    SharedButton
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    preset: {
      type: Object,
    },
    fieldSetting: {
      type: Object,
      required: false,
    },
    bookingStatusMapping: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // statusDetectorConfig: {
    //   type: Array,
    //   required: false,
    //   default: () => ([]),
    // },
  },
  created() {},
  data() {
    return {};
  },
  computed: {
    fields() {
      let listSetting = this.fieldSetting?.list || [];
      if (listSetting) {
        return listSetting
          .filter((field) => field.is_show)
          .sort((a, b) => a.order - b.order);
      } else {
        return [];
      }
    },
    isCanEdit() {
      return this.bookingStatusMapping.show_edit_button?.includes(this.booking.status)
    },
    isCanView() {
      return this.bookingStatusMapping.show_view_button?.includes(this.booking.status)
    },
    isCanReadOnly() {
      return this.bookingStatusMapping.show_readonly_button ?.includes(this.booking.status)
    },
    bookingDateText() {
      const startAt = moment(new Date(this.booking.start_at));
      const endAt = moment(new Date(this.booking.end_at));
      if (!this.booking.end_at) {
        return `${startAt.format("YYYY-MM-DD HH:mm")}`;
      }
      if (!this.booking.start_at) {
        return `${endAt.format("YYYY-MM-DD HH:mm")}`;
      }
      if (startAt.isSame(endAt, 'minute')) {
        return `${startAt.format("YYYY-MM-DD HH:mm")}`;
      }
      if (startAt.isSame(endAt, 'day')) {
        return `${startAt.format("YYYY-MM-DD HH:mm")} ~ ${endAt.format(
          "HH:mm"
        )}`;
      }
      return `${startAt.format("YYYY-MM-DD HH:mm")} ~ ${endAt.format(
        "YYYY-MM-DD HH:mm"
      )}`;
    },
    statusText() {
      return (
        this.bookingStatusMapping[this.booking.status] ?? this.booking.status
      );
    },
  },
  methods: {
    async updateStatus(value) {
      await bookingApi.updateStatus(this.booking.id, { status: value });
      this.$emit("fetch");
    },
    goToEdit() {
      this.$router.push({
        name: "LiffBookingEdit",
        params: {
          bookingId: this.booking.id,
          bookingPresetId: this.preset.id,
          orgCode: this.$route.params.orgCode
        }
      })
    },
    goToView() {
      this.$router.push({
        name: "LiffBookingShow",
        params: {
          bookingId: this.booking.id,
          bookingPresetId: this.preset.id,
          orgCode: this.$route.params.orgCode
        }
      })
    },
    goToReadOnly() {
      this.$router.push({
        name: "LiffBookingReadOnly",
        params: {
          bookingId: this.booking.id,
          bookingPresetId: this.preset.id,
          orgCode: this.$route.params.orgCode
        }
      })
    },
    getFieldValue(field) {
      if (field.key == "booking_date") {
        return this.bookingDateText;
      } else if (field.key == "status") {
        return this.statusText;
      } else if (field.key.startsWith("booking_data.")) {
        const [, fieldId] = field.key.split(".");
        const item = this.booking.data.find(
          (item) => item.field_id === fieldId
        );
        return item ? item.value : "";
      }
      return this.booking[field.key];
    },
  },
};
</script>

<style scoped>
.s-item {
  display: flex;
  align-items: center;
  background-color: var(--s-white);
}

.s-item-info {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  padding: 1rem;

  box-shadow: rgb(from var(--s-primary) r g b / 0.5) 0px 2px 8px 0px;
  border-radius: 5px;
}

.w-full {
  width: 100%;
}

.list-button {
  font-size: 13px;
  line-height: 18px;
  padding: 6px 16px;
  font-weight: 600;
}
</style>
